<div class="about-wrapper">
  <section class="about-hero">
    <div
      class="color-box"
      *ngFor="let color of heroColors"
      [style.backgroundColor]="color"
    ></div>
    <img [src]="heroImage" alt="Lady with arms folded" />
    <div class="hero-texts">
      <h1>Atrizult Consult</h1>
      <div class="hero-bottom-text">
        <div class="orange-line"></div>
        <span>{{ "about-us-page.heroText" | translate }}</span>
        <div class="orange-line"></div>
      </div>
    </div>
  </section>
  <section class="who-we-are-box">
    <p class="who-we-are-text">
      <span>{{ "about-us-page.whoWeAre.who" | translate }}</span>
      <span>{{ "about-us-page.whoWeAre.we" | translate }}</span>
      <span>{{ "about-us-page.whoWeAre.are" | translate }}</span>
    </p>
    <p class="who-we-are-para">
      {{ "about-us-page.whoWeAre.details" | translate }}
    </p>
  </section>
  <section class="mission-section">
    <span class="section-title">
      {{ "about-us-page.mission.title" | translate }}
    </span>
    <p class="mission-para">
      <img src="assets/svgs/icons/quotation-icon.svg" alt="" class="up-quote" />
      <img
        src="assets/svgs/icons/quotation-icon.svg"
        alt=""
        class="down-quote"
      />
      {{ "about-us-page.mission.details" | translate }}
    </p>
  </section>
  <section class="what-we-do-section">
    <p class="what-we-do-para">
      {{ "about-us-page.whatWeDo.details.1" | translate }}
      <br />
      {{ "about-us-page.whatWeDo.details.2" | translate }} <br />
      {{ "about-us-page.whatWeDo.details.3" | translate }}
    </p>
    <p class="what-we-do-text">
      <span>{{ "about-us-page.whatWeDo.what" | translate }}</span>
      <span>{{ "about-us-page.whoWeAre.we" | translate }}</span>
      <span>{{ "about-us-page.whatWeDo.do" | translate }}</span>
    </p>
  </section>
  <section class="team-section">
    <span class="section-title">{{ "footer.about-team" | translate }}</span>
    <div class="team-members">
      <div *ngFor="let member of teamMembers" class="team-member-card">
        <img
          src="{{ member.imageUrl || defaultAvatar }}"
          alt="{{ member.name }}"
        />
        <div class="tem-member-details">
          <span class="team-member-name">{{ member.name }}</span>
          <span class="team-member-job-title">{{
            member.jobTitle | translate
          }}</span>
        </div>
      </div>
    </div>
  </section>
</div>
